import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import { Main, Top, Bottom, Side, StyledLink, Div, Obj, StyledArrow, Container, Meta, Hover } from "./styles"
import Card from "../card"
import Separator from "../separator"
import { H3, P } from "../typography"

const Notification = ({ notification, close, actionHandler, ...rest }) => {
  const [fade, setFade] = useState(false)

  const dismiss = (event) => {
    event.preventDefault()
    setFade(true)
    setTimeout(() => close(notification.id), 500)
  }

  const cardContent = (
    <Fragment>
      <Main>
        <Top>
          {notification.title && (
            <H3 marginless variant="secondaryReadable">
              {notification.title}
            </H3>
          )}
          <P marginless variant="secondaryReadable">
            {notification.content}
          </P>
        </Top>

        {(notification.created_at || notification.created_by_name) && (
          <>
            <Separator mobileOnly={false} />

            <Bottom>
              <Meta>{notification.created_at}</Meta>
              <Meta>{notification.created_by_name}</Meta>
            </Bottom>
          </>
        )}
      </Main>

      {(close || notification.link) && (
        <Side>
          {close && <Obj onClick={dismiss}>&times;</Obj>}
          {(notification.link || notification.view_participant_profile_id) && <StyledArrow />}
        </Side>
      )}
    </Fragment>
  )

  const card = (
    <Card variant="secondary" paddingless marginless={rest.marginless}>
      {notification.link ? (
        <StyledLink href={notification.link}>{cardContent}</StyledLink>
      ) : notification.view_participant_profile_id ? (
        <Hover>
          <StyledLink onClick={() => actionHandler(notification.view_participant_profile_id)}>{cardContent}</StyledLink>
        </Hover>
      ) : (
        <Div>{cardContent}</Div>
      )}
    </Card>
  )

  return <Container className={fade ? "slide-out" : ""}>{card}</Container>
}

Notification.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string,
    created_by_name: PropTypes.string,
    link: PropTypes.string
  }),
  close: PropTypes.func
}

export default Notification
